import { TALKI_GUIDE } from "@/lib/sceneCast";

type TalkiGuideLineProps = {
  text: string;
};

export const TalkiGuideLine = ({ text }: TalkiGuideLineProps) => (
  <div className="mx-auto flex max-w-sm items-start gap-3 text-left">
    <img
      src={TALKI_GUIDE.src}
      alt=""
      className="mt-0.5 h-10 w-10 shrink-0 rounded-full object-cover object-top"
    />
    <div>
      <p className="text-overline text-orange-700">
        {TALKI_GUIDE.name}
      </p>
      <p className="mt-0.5 text-[15px] leading-snug text-neutral-900">{text}</p>
    </div>
  </div>
);
